import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getLoyaltySettings } from "../api/loyaltyApi";

const LoyaltySettingsContext = createContext({ settings: null, loading: true, error: "" });

export const LoyaltySettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const location = useLocation();
  const refresh = useCallback(async () => {
    try {
      const next = await getLoyaltySettings();
      setSettings((current) => current?.revision > next.revision ? current : next);
      setError("");
    } catch {
      setError("Не вдалося перевірити доступність розділу. Спробуйте ще раз.");
    } finally {
      setLoading(false);
    }
  }, []);
  useEffect(() => { refresh(); }, [refresh, location.pathname]);
  useEffect(() => {
    const receive = (event) => { setSettings((current) => current?.revision > event.detail?.revision ? current : event.detail); setError(""); setLoading(false); };
    window.addEventListener("loyalty-settings-updated", receive);
    window.addEventListener("focus", refresh);
    const timer = window.setInterval(() => { if (!document.hidden) refresh(); }, 30000);
    return () => {
      window.removeEventListener("loyalty-settings-updated", receive);
      window.removeEventListener("focus", refresh);
      window.clearInterval(timer);
    };
  }, [refresh]);
  return <LoyaltySettingsContext.Provider value={{ settings, loading, error, refresh }}>{children}</LoyaltySettingsContext.Provider>;
};

export const useLoyaltySettings = () => useContext(LoyaltySettingsContext);

export const LoyaltyVisibleRoute = ({ children, redirectTo = "/" }) => {
  const { settings, loading, error, refresh } = useLoyaltySettings();
  if (loading && !settings) return <div role="status">Завантаження...</div>;
  if (!settings) return <div role="alert">{error}<button type="button" onClick={refresh}>Повторити</button></div>;
  if (!settings.visible) return <Navigate to={redirectTo} replace />;
  return children;
};
